import Naluri from '~/common/api/naluri'
import {
  FOOD_JOURNAL_GET_QUICK_REPLIES_BEGIN,
  FOOD_JOURNAL_GET_QUICK_REPLIES_SUCCESS,
  FOOD_JOURNAL_GET_QUICK_REPLIES_FAILURE,
  FOOD_JOURNAL_GET_QUICK_REPLIES_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getQuickReplies(journalID) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: FOOD_JOURNAL_GET_QUICK_REPLIES_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = Naluri.get(`/api/expert/dishes/${journalID}/quick_replies`)

      doRequest.then(
        (res) => {
          dispatch({
            type: FOOD_JOURNAL_GET_QUICK_REPLIES_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: FOOD_JOURNAL_GET_QUICK_REPLIES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetQuickRepliesError() {
  return {
    type: FOOD_JOURNAL_GET_QUICK_REPLIES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case FOOD_JOURNAL_GET_QUICK_REPLIES_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        replies: state.replies.clear(),
        getQuickRepliesPending: true,
        getQuickRepliesError: null,
      };

    case FOOD_JOURNAL_GET_QUICK_REPLIES_SUCCESS:
      // The request is success
      let newReplies = state.replies.withMutations(reply => {
        action.data.suggestions.forEach(data => {
          if(reply !== undefined){
            const temp = reply.find(item =>item.locale === data.locale)
            if(!temp){
              reply.push(data)
            }
          }
          else {
            reply.push(data)
          }
        })
      })
      return {
        ...state,
        replies: newReplies,
        getQuickRepliesPending: false,
        getQuickRepliesError: null,
      };

    case FOOD_JOURNAL_GET_QUICK_REPLIES_FAILURE:
      // The request is failed
      return {
        ...state,
        getQuickRepliesPending: false,
        getQuickRepliesError: action.data.error,
      };

    case FOOD_JOURNAL_GET_QUICK_REPLIES_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getQuickRepliesError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/food-journal/redux/getQuickReplies.js